let uuid = 0;

export const getUuid = (name: string = "") => {
  uuid++;
  return `${name}${uuid}`;
};

/**
 * Formats an ID for abbreviated display
 * - IDs with prefix (agt_, bot_, usr_, etc): shows prefix + last N chars
 * - IDs without prefix (pure UUID): shows first N chars
 *
 * @param id - The ID to format
 * @param options - Configuration options
 * @param options.suffixLength - Number of chars to show from end (for prefixed IDs) - default: 4
 * @param options.prefixLength - Number of chars to show from start (for non-prefixed IDs) - default: 8
 *
 * @example
 * formatId("agt_01934c2f-8a2b-7123-9abc-def123456789") // "agt_...6789"
 * formatId("bot_01934c2f-1234-7abc-8def-a1b2c3d4e5f6") // "bot_...e5f6"
 * formatId("01934c2f-8a2b-7123-9abc-def123456789")     // "01934c2f"
 */
export function formatId(
  id: string,
  options?: {
    suffixLength?: number;
    prefixLength?: number;
  }
): string {
  const { suffixLength = 4, prefixLength = 8 } = options ?? {};

  // Check if ID has a prefix (contains underscore)
  const underscoreIndex = id.indexOf("_");

  if (underscoreIndex !== -1) {
    // Has prefix: show prefix + "..." + last N chars
    const prefix = id.substring(0, underscoreIndex + 1); // Include the underscore
    const suffix = id.slice(-suffixLength);
    return `${prefix}...${suffix}`;
  }

  // No prefix: show first N chars (fallback)
  return id.substring(0, prefixLength);
}
